import { NewProduct } from '../../types/Products/newProduct';
import { request } from '../../utils/request';

export const createNewProduct = async (
  formData: NewProduct,
  authToken: string,
  store_id: number
) =>
  request({
    method: 'POST',
    url: `/products`,
    headers: {
      Authorization: `Bearer ${authToken}`,
    },
    formData: {
      ...formData,
      store_id,
    },
    callback: undefined,
    onError: (err) => {
      throw err;
    },
  });
